import React from 'react'

const Insight = () => {
  return (
    <div className="relative w-full h-64 md:h-96 bg-cover bg-center" style={{ backgroundImage: "url('/assets/banner.jpg')" }}>
    <div className="absolute inset-0 bg-black bg-opacity-50 flex flex-col items-center justify-center text-center text-white p-4">
    </div>
  </div>
 )
}

export default Insight;